/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Bed } from './Bed';
import {
    BedFromJSON,
    BedFromJSONTyped,
    BedToJSON,
    BedToJSONTyped,
} from './Bed';

/**
 * 
 * @export
 * @interface BulkUpdateBeds200Response
 */
export interface BulkUpdateBeds200Response {
    /**
     * 
     */
    data?: Array<Bed>;
}

/**
 * Check if a given object implements the BulkUpdateBeds200Response interface.
 */
export function instanceOfBulkUpdateBeds200Response(value: object): value is BulkUpdateBeds200Response {
    return true;
}

export function BulkUpdateBeds200ResponseFromJSON(json: any): BulkUpdateBeds200Response {
    return BulkUpdateBeds200ResponseFromJSONTyped(json, false);
}

export function BulkUpdateBeds200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateBeds200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(BedFromJSON)),
    };
}

export function BulkUpdateBeds200ResponseToJSON(json: any): BulkUpdateBeds200Response {
    return BulkUpdateBeds200ResponseToJSONTyped(json, false);
}

export function BulkUpdateBeds200ResponseToJSONTyped(value?: BulkUpdateBeds200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(BedToJSON)),
    };
}

